import type { GanttSnapMode } from '../define.js';
import { MS_PER_DAY } from './time-axis-math.js';

const MS_PER_WEEK = 7 * MS_PER_DAY;

/** 1970-01-01 was a Thursday → shift so the week aligns to Monday. */
const WEEK_EPOCH_OFFSET = 4 * MS_PER_DAY;

/**
 * Snaps an epoch-ms timestamp to the active grid.
 *
 * - `'day'` snaps to the nearest UTC midnight.
 * - `'week'` snaps to the nearest Monday 00:00 UTC.
 * - `'none'` returns the input unchanged.
 */
export function snapDate(ms: number, mode: GanttSnapMode): number {
  if (mode === 'none') return ms;
  if (mode === 'week') {
    return (
      Math.round((ms - WEEK_EPOCH_OFFSET) / MS_PER_WEEK) * MS_PER_WEEK +
      WEEK_EPOCH_OFFSET
    );
  }
  return Math.round(ms / MS_PER_DAY) * MS_PER_DAY;
}
